import React from "react";
import Store from "./Store";

const generateStoreList = function(storeList) {
  const storeListObj = storeList;
  const storeListGenerated = storeListObj.map((store, index) => (
    <Store.component index={index} key={store.fcId} storeObj={store} />
  ));
  return storeListGenerated;
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: generateStoreList,
  component: generateStoreList,
};

export default ProjectComponent;
